import { getCampaigns, getCampaign } from '@/graphl/queries/campaign'
import { formatDate, formatPrice } from '@/helpers'

const state = {
  listCampaigns: [],
  loading: false,
  metaDataCampaigns: {},
  campaign: {}
}

const mutations = {
  'TOGGLE_LOADING_CAMPAIGNS' (state, payload = false) {
    state.loading = !!payload
  },
  'SET_LIST_CAMPAIGNS' (state, payload) {
    state.listCampaigns = payload
  },
  'SET_METADATA_CAMAPAIGNS' (state, payload) {
    state.metaDataCampaigns = payload
  },
  'SET_DATA_CAMAPAIGN' (state, payload) {
    state.campaign = payload
  }
}

const actions = {
  getCampaigns ({commit}, page, limit ) {
    commit('TOGGLE_LOADING_CAMPAIGNS', true)
    getCampaigns (page, limit).then( res => {
      const { collection } = res.data.campaigns
      const { metadata } = res.data.campaigns
      this.campaigns = collection.map((campaign) => ({
        id: campaign.id,
        humanizedStatus: campaign.humanizedStatus,
        name: campaign.name,
        value: formatPrice(campaign.value),
        dueDate: formatDate(campaign.dueDate),
        status: campaign.status,
        peopleCount: campaign.peopleCount.toLocaleString('pt-BR'),
        peopleImportedCount: campaign.peopleImportedCount.toLocaleString('pt-BR'),
        peopleAmount: formatPrice(campaign.peopleAmount),
        peopleRegisteredCount: campaign.peopleRegisteredCount.toLocaleString('pt-BR'),
        registeredAmount: formatPrice(campaign.registeredAmount),
        peoplePaidCount: campaign.peoplePaidCount.toLocaleString('pt-BR'),
        paidAmount: formatPrice(campaign.paidAmount),
        paidCountPercentage: campaign.paidCountPercentage,
        paidAmountPercentage: campaign.paidAmountPercentage
      }))
      commit('SET_LIST_CAMPAIGNS', this.campaigns)
      commit('SET_METADATA_CAMAPAIGNS', metadata)
      commit('TOGGLE_LOADING_CAMPAIGNS', false)
    }).catch(e => {
      this.erros = e
      commit('TOGGLE_LOADING_CAMPAIGNS', false)
    })
  },

  getIdCampaign ({commit}, id ) {
    commit('TOGGLE_LOADING_CAMPAIGNS', true)
    getCampaign (id)
      .then( res => {
        const { campaign } = res.data
        campaign.dueDate = formatDate(campaign.dueDate)
        commit('SET_DATA_CAMAPAIGN', campaign)
        commit('TOGGLE_LOADING_CAMPAIGNS', false)
      }).catch(e => {
        this.erros = e
        commit('TOGGLE_LOADING_CAMPAIGNS', false)
      })
  },

  setCampaign({ commit }, payload) {
    commit('SET_DATA_CAMAPAIGN', payload)
  },

  toggleLoadingCampaigns({ commit }, isLoading = false) {
    commit('TOGGLE_LOADING_CAMPAIGNS', isLoading)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
